
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AddressBlock_generic.html?raw';
import countryData from './CountryData.json?raw';


import _StatefulBase from '../../../moreCore/UI/_StatefulBase/_StatefulBase';
import _LabelInputBase from '../../../moreCore/UI/_LabelInputBase/_LabelInputBase';
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import Edit from '../../../moreCore/UI/Edit/Edit';

//import DataItems = require("DataItems");


class AR_AddressBlock_generic extends compose(_LabelInputBase) {
    templateString: any = template;

    // nodes
    postalCode_container: HTMLElement;
    settlement_container: HTMLElement;
    province_container: HTMLElement;
    country_container: HTMLElement;
    addressInformation_container_1: HTMLElement;
    addressInformation_container_2: HTMLElement;
    addressInformation_container_3: HTMLElement;

    country: MdsLax<InstanceType<typeof SelectBox>>;
    postalCode: MdsLax<InstanceType<typeof Edit>>;
    settlement: MdsLax<InstanceType<typeof Edit>>;
    province: MdsLax<InstanceType<typeof Edit>>;

    addressInformation_1: MdsLax<InstanceType<typeof Edit>>;
    addressInformation_2: MdsLax<InstanceType<typeof Edit>>;
    addressInformation_3: MdsLax<InstanceType<typeof Edit>>;

    // labels
    _addressInformation_1_label = (this as any).translations["ArtistRegistration__addressInformation_1_label"];
    _addressInformation_2_label = (this as any).translations["ArtistRegistration__addressInformation_2_label"];
    _addressInformation_3_label = (this as any).translations["ArtistRegistration__addressInformation_3_label"];
    _country_label: string = (this as any).translations["AdressBlock__country_label"]; //"Country";
    _postalCode_label: string = (this as any).translations["AdressBlock__postalCode_label"]; // "Postal Code";
    _province_label: string = (this as any).translations["AdressBlock__province_label"]; // "Province";
    _settlement_label: string = (this as any).translations["AddressBlock__settlement"]; // "Province";



    // falls man sie irgendwann braucht

    //EU_Countries: string[] = ["al", "ad", "at", "by", "be", "ba", "bg", "hr", "cz", "dk",
    //    "ee", "fo", "fi", "fr", "de", "gi", "gr", "va", "hu", "is", "ie", "it", "lv",
    //    "li", "lt", "lu", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro",
    //    "ru", "sm", "rs", "sk", "si", "es", "se", "ch", "ua", "gb"];

    preferredCountries: string[] = ["de", "at", "be", "ch", "es", "fr", "it", "lu", "nl", "gb"]; 


    // Props ------------------------------------------------------------START
    AllCountriesData: Array<object> = JSON.parse(countryData);
    protected topCountries: Array<object> = [];

    allFieldsTotal: Array<string> = ["addressInformation_1", "addressInformation_2", "addressInformation_3", "postalCode", "settlement", "province", "country"];

    _value: object = {};

    isValid: boolean = true;

    // Events -------------------------------------------------------START
    _onChange_addressInformation_1(): void {
        this.addValue(this.addressInformation_1);
        this._onChange();
    }

    _onChange_addressInformation_2(): void {
        this.addValue(this.addressInformation_2);
        this._onChange();
    }

    _onChange_addressInformation_3(): void {
        this.addValue(this.addressInformation_3);
        this._onChange();
    }

    _onChange_Country(): void {
        this.addValue(this.country);
        this._onChange();
    }

    _onChange_postalCode(): void {
        this.addValue(this.postalCode);
        this._onChange();
    }
    _onChange_settlement(): void {
        this.addValue(this.settlement);
        this._onChange();
    }
   
    _onChange_province(): void {
        this.addValue(this.province);
        this._onChange();
        
    }

    _onChange(): void {
        // wir müssen eine zwischenprüfung für Datenvöllzähligkeit machen ohne Inputvalidierung Style zu setzen, damit wir das value für das Formular liefern können
        let isDataComplete = true;
        let mandatoryKeys = []

        for (let key of this.allFieldsTotal) {
            if (this[key].isMandatory) {
                mandatoryKeys.push(key);
            }
        }

        for (let i = 0; i < mandatoryKeys.length; i++) {
            if (!this._value.hasOwnProperty(mandatoryKeys[i]) || this._value[mandatoryKeys[i]] == null || this._value[mandatoryKeys[i]] == "") {
                isDataComplete = false;
            }
        }

        this.isValid = isDataComplete;

        if (isDataComplete) {
            this.emit("valueChange");
        }
    }
   

    // Events -------------------------------------------------------END

    validateInput(): boolean {

        if (this.validationEnabled) {
            this.isValid = this.dataCompletnessCheck();
        } else {
            this.isValid = true;
        }
        return this.isValid;
    }

    dataCompletnessCheck(): boolean {

        let result = true;
        let mandatoryKeys = []

        for (let key of this.allFieldsTotal) {
            if (this[key].isMandatory) {
                mandatoryKeys.push(key);
            }
        }

        for (let i = 0; i < mandatoryKeys.length; i++) {

            let inp: MdsLax<InstanceType<typeof _StatefulBase>> = this[mandatoryKeys[i]];
            inp.validateInput();

            if (!this._value.hasOwnProperty(mandatoryKeys[i]) || this._value[mandatoryKeys[i]] == null || this._value[mandatoryKeys[i]] == "" ) {
                result = false;
            }
        }

        return result;
    }



    populateCountrySelect(node: MdsLax<InstanceType<typeof SelectBox>>): void {

        for (let iso2 of this.preferredCountries) {
            for (let country of this.AllCountriesData) {
                if (country["iso2"]==iso2) {
                    this.topCountries.push(country);
                }
            }
        }

        for (let i = 0; i < this.topCountries.length; i++) {
            let country = this.topCountries[i];
            node.addEntry(country["iso2"], country["name"], true);
        }

        node.addEntry("", "&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473", false);

        for (var i = 0; i < this.AllCountriesData.length; i++) {
            let country = this.AllCountriesData[i];
            node.addEntry(country["iso2"], country["name"], true);
        }

        node.on("valueChange", function (value) { });
        node.setPlaceholder("bitte wählen - please choose");

        let brLanguage = navigator.language.slice(-2).toLowerCase()

        node.setValue(brLanguage, true);

        node.startup();

    }

    // Preferred counries vorne in AllCountriesData platzieren, damit sie im SelectBox oben angezeigt werden
    addPreferredCountries(): void {

        for (let i = 0; i < this.preferredCountries.length; i++) {
            let countryName: string = this.preferredCountries[i];
            for (let i = 0; i < this.AllCountriesData.length; i++) {

                if (this.AllCountriesData[i]["iso2"] == countryName) {
                    this.topCountries.push(this.AllCountriesData[i]);
                }
            }
        }

        //countries.unshift(...topCountries);
    }

    addValue(input: MdsLax<InstanceType<typeof _StatefulBase>>): void {
        let value = input.getValue()
        if (value && input.validateInput()) {

            this._value[this.getAttachPointNameForWidget(input)] = value;

        } else {
            delete this._value[this.getAttachPointNameForWidget(input)];
        }
    }

    getAttachPointNameForWidget(widget: MdsLax<InstanceType<typeof _StatefulBase>>): string {
        for (let attachPointName of this._attachPoints) {
            if (this[attachPointName] == widget) {
                return attachPointName;
            }
        }
    }

    //Doku
    getDocumentationContent(): string {
        return "docu";
    }
    //-DOJO----------------------------------------

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
        this.populateCountrySelect(this.country);

        this._onChange_Country();
    }
}

export default mdsWidget(AR_AddressBlock_generic);